import moment from "moment";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import Popup from "../../components/popup";
import axios from 'axios';
const PurchaseAlertPage = ({ data, handleClosed, show = false, sadadMessage, CartID }) => {
  const location = useLocation();
  const { t: trans, i18n } = useTranslation(["mobileCommon", "mobileHeading", "messages", "new", "error", "info"]);
  const urlParams = new URLSearchParams(location.search);
  const lang = localStorage.getItem('i18nextLng');
  const languageDir = 'language-' + lang;
  const [doneDate, setDoneDate] = useState(new moment().format('yyyy-MM-DD hh:mm A'));
  const { id } = useParams();
  const popRef = useRef(null);
  const [showFinalPopup, setShowFinalPopup] = useState(show);


  useEffect(() => {

    setShowFinalPopup(show);

  }, [show]);
  useEffect(() => {

    if (handleClosed && showFinalPopup == false) {
      handleClosed();
    }

  }, [showFinalPopup]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (popRef.current && !popRef.current.contains(event.target) && showFinalPopup === true) {
        setShowFinalPopup(false);

      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFinalPopup]);

  useEffect(() => {


    console.log("isPayed:", id);
    if (id) {
      axios.request({
        baseURL: '/',
        url: lang + "/api/cart/isPayed",
        params: {
          id: id
        },
        method: "put",
      }).then(response => {
      }).catch(error => {
        console.log(error);
      })
    }
  }, []);
  return (
    <Popup show={showFinalPopup}>
      <div className="w-full h-full flex justify-center items-center" >
        <div className="cart-finalized" ref={popRef}>
          <div className="cart-finalized-container">
            <img src="/assets/images/finalized.svg" />
          </div>
          <div className="flex flex-wrap justify-center">
            <span className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
            <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
          </div>
          <div className="flex flex-row justify-center">
            <span className="text-34 font-bold text-gray mx-2"> {trans("new:order_No")}</span>
            <span className="text-34 font-bold text-gray mx-2">{CartID && CartID}</span>
          </div>

          {
            sadadMessage &&
            <>
              <div className="flex flex-col items-center nice-gap-2rem">
                <span className="text-34 font-bold text-gray mx-2">لتفادي إلغاء الطلب رجاء سداد مبلغ </span>
                <span className="text-34 font-bold text-primary mx-2">10000 ريال</span>
              </div>
              <div className="flex flex-row justify-center">
                <span className="text-34 font-bold text-gray mx-2">عن طريق</span>
                <span className="text-34 font-bold text-note mx-2">سداد</span>
                <span className="text-34 font-bold text-gray mx-2">خلال ال 24 ساعة</span>
              </div>

              <div className="cart-finalized-code"
                onClick={() => {

                  navigator.clipboard.writeText("900000878779798");
                }}
              >
                <code className="text-white text-30">900000878779798</code>
                <img src="/assets/icons/copy.svg" alt='copy' />
              </div>
            </>
          }

        </div>
      </div>
    </Popup>

  )
}

export default PurchaseAlertPage;